import styled from 'styled-components';
import { Flexer } from '@ontruck/orc';

const StyledHeader = styled(Flexer.Parent)`
  padding: 8px 16px;
  background-color: var(--grey100);
  justify-content: space-between;
  align-items: center;
`;

StyledHeader.Title = styled(Flexer.Child).attrs(() => ({
  flexGrow: '1',
}))`
  display: flex;
  align-items: center;
  color: var(--grey900);
  font-size: ${({ theme }) => theme.base.textSizes.M};
`;

StyledHeader.Links = styled(Flexer.Child).attrs(() => ({
  flexGrow: '0',
}))`
  display: flex;

  svg {
    max-width: 12px;
    max-height: 12px;
    margin-right: 8px;

    path {
      fill: var(--primary500);
    }
  }
`;

export default StyledHeader;
